// extracted by mini-css-extract-plugin
module.exports = {"button":"passwordReset_button__pOjhy","disabledOutline":"passwordReset_disabledOutline__X76Ux","heading":"passwordReset_heading__ddkxO"};